export interface Data {
  size?: number | string;
  icon?: string;
  color?: string;
}

export const OutputIds = {
  Click: 'click'
};
